import { ChunkSnippet } from "@/src/graphql/generated";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export type DealSearchState = {
  snippets: {
    [key: string]: Partial<ChunkSnippet>;
  };
};

const initialState: DealSearchState = {
  snippets: {},
};

export const { actions, reducer } = createSlice({
  name: "dealSearchState",
  initialState,
  reducers: {
    addSnippet: (
      state,
      action: PayloadAction<{
        snippet: Partial<ChunkSnippet>;
        searchTerm: string;
        documentChunkID: string;
      }>,
    ) => {
      state.snippets[
        `${action.payload.searchTerm}-${action.payload.documentChunkID}`
      ] = action.payload.snippet;
    },
  },
});
